import { Injectable, Injector } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { RequestService } from "../services/request.service";
import { PermissionService } from "../services/permission.service";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { PublicacionesPlataformaService } from "../services/publicaciones-plataforma.service";
@Injectable()
export class ReqInterceptor implements HttpInterceptor {
  constructor(
    private requestServ: RequestService,
    private router: Router,
    private injector: Injector
  ) {}

  private esErrorAuthz(err: HttpErrorResponse): boolean {
    return err.error?.respuesta?.tipo === "AUTHZ_FORBIDDEN";
  }

  private getMensajeError(err: HttpErrorResponse): string {
    const respuesta = err.error?.respuesta;
    if (typeof respuesta === "string") return respuesta;
    if (respuesta?.mensaje) return respuesta.mensaje;
    if (respuesta?.message) return respuesta.message;
    return "Ocurrio un error procesando la solicitud";
  }

  /**
   * Centraliza errores HTTP y convierte el 503 de mantenimiento en un bloqueo
   * global no descartable usando el contrato autoritativo del backend.
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const omitirErrorGlobal = req.headers.has("X-Skip-Global-Error");
    const request = omitirErrorGlobal
      ? req.clone({ headers: req.headers.delete("X-Skip-Global-Error") })
      : req;
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && ~~(event.status / 100) > 3) {
        }
        return event;
      }),
      catchError((err: any, caught) => {
        if (omitirErrorGlobal) return throwError(err);
        if (err instanceof HttpErrorResponse) {
          if (err.status === 403) {
            if (this.esErrorAuthz(err)) {
              // Solo invalidar el cache cuando hay DIVERGENCIA real entre el
              // estado local y el backend: el cache "cree" que el usuario
              // tiene un permiso pero el backend lo rechazo. Si el usuario
              // simplemente nunca tuvo ese permiso (caso comun de gates
              // granulares en modales), el 403 es esperado y NO debemos
              // invalidar — sino se descalabran otros consumidores como el
              // sidebar que ya leyo el cache para decidir visibilidad.
              try {
                const permSvc = this.injector.get(PermissionService);
                const permisosFaltantes: Array<{ codigo: string }> =
                  err.error?.respuesta?.permisosRequeridos || [];
                const codigos = permisosFaltantes
                  .map((p) => p?.codigo)
                  .filter((c): c is string => !!c);
                const hayDivergencia = codigos.some((c) => permSvc.can(c));
                if (hayDivergencia) {
                  permSvc.invalidate();
                }
              } catch (_e) {
                /* ignorar — fallback sin invalidacion */
              }
            } else {
              this.requestServ.showAlert(this.getMensajeError(err), "error");
            }
          }
          if (err.status === 401) {
            this.requestServ.showAlert(this.getMensajeError(err), "error");
          }
          if (err.status === 500) {
            this.requestServ.showAlert(this.getMensajeError(err), "error");
          }
          if (
            err.status === 503 &&
            err.error?.respuesta?.tipo === "MANTENIMIENTO_ACTIVO"
          ) {
            const publicacionesService = this.injector.get(
              PublicacionesPlataformaService
            );
            publicacionesService.activarDesdeError(err.error.respuesta);
          }
          if (err.status === 404) {
            this.requestServ.showAlert(this.getMensajeError(err), "error");
          }
          if (err.status === 423) {
            this.router.navigateByUrl("/expired");
            Swal.fire({
              title: "AVISO",
              text: "Su plan se encuentra caducado, comuníquese por favor al siguiente teléfono para su renovación: 0989641331, puede llamar o escribir por WhatsApp",
              icon: "warning",
              confirmButtonColor: "#343a40",
              cancelButtonColor: "#d33",
              confirmButtonText: "Entendido",
            });
          }
          if (err.status === 426) {
            Swal.fire({
              title: "Sesión desactualizada",
              text:
                "Sus accesos cambiaron, por favor inicie sesión nuevamente para continuar.",
              icon: "info",
              confirmButtonColor: "#343a40",
              confirmButtonText: "Entendido",
              allowOutsideClick: false,
            }).then(() => {
              this.requestServ.cerrarSesion();
            });
          }
          if (err.status === 424) {
            console.log(err)
            const respData = err.error?.respuesta;
            if (respData && typeof respData === 'object' && respData.diasParaExpirar != null) {
              let mensaje = "Su plan caducara en  " + respData.diasParaExpirar  + " dia(s) , comuníquese por favor al siguiente teléfono para su renovación 0989641331, puede llamar o escribir por WhatsApp"
              Swal.fire({
                title: "AVISO",
                text: mensaje,
                icon: "warning",
                confirmButtonColor: "#343a40",
                cancelButtonColor: "#d33",
                confirmButtonText: "Entendido",
              });
            } else {
              const msg = typeof respData === 'string' ? respData : 'Error de autenticación';
              this.requestServ.showAlert(msg, "error");
            }
          }
          if (err.status === 425) {
            Swal.fire({
              title: "AVISO",
              text: "Se ha consumido la cantidad total de documentos contratado comuníquese por favor al siguiente teléfono para su revisión: 0989641331, puede llamar o escribir por WhatsApp",
              icon: "warning",
              confirmButtonColor: "#343a40",
              cancelButtonColor: "#d33",
              confirmButtonText: "Entendido",
            });
          }
          if (err.status === 435) {
            Swal.fire({
              title: "AVISO",
              text: err.error.respuesta,
              icon: "warning",
              confirmButtonColor: "#343a40",
              cancelButtonColor: "#d33",
              confirmButtonText: "Entendido",
            });
          }
          if (err.status === 400) {
            //console.log("Erroorororr: ", err);
            this.requestServ.showAlert(this.getMensajeError(err), "error");
          }
          return throwError(err); // Patch: Replaced Observable.throw for throwError for prevent errors
        }
        return throwError(err);
      })
    );
  }
}
